import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderEditingComponent } from './order-editing.component';
import { OrderEditingPreviewComponent } from './components/order-editing-preview/order-editing-preview.component';
import { StorybookModule } from '@app/storybook/storybook.module';
import { FeaturesModule } from '@app/features/features.module';
import { SharedModule } from '@app/sharedModule/shared.module';
import { SettingsModule } from '../settings/settings.module';
import { OrderEditingFormComponent } from './components/order-editing-form/order-editing-form.component';
import { OrderEditingFormEditsComponent } from './components/order-editing-form/components/order-editing-form-edits/order-editing-form-edits.component';
import { OrderEditingFormRefundHandlingComponent } from './components/order-editing-form/components/order-editing-form-refund-handling/order-editing-form-refund-handling.component';
import { OrderEditingFormRepricingComponent } from './components/order-editing-form/components/order-editing-form-repricing/order-editing-form-repricing.component';
import { OrderEditingFormShippingComponent } from './components/order-editing-form/components/order-editing-form-shipping/order-editing-form-shipping.component';
import { OrderEditingFormPeriodComponent } from './components/order-editing-form/components/order-editing-form-period/order-editing-form-period.component';
import { OrderEditingHeaderComponent } from './components/order-editing-header/order-editing-header.component';
import { OrderEditingFormAddressValidationComponent } from './components/order-editing-form/components/order-editing-form-address-validation/order-editing-form-address-validation.component';
import { AddressValidationConfigurationsComponent } from './components/order-editing-form/components/order-editing-form-address-validation/components/address-validation-configurations/address-validation-configurations.component';
import { AddressValidationFlaggedOrdersComponent } from './components/order-editing-form/components/order-editing-form-address-validation/components/address-validation-flagged-orders/address-validation-flagged-orders.component';
import { AddressValidationPreviewComponent } from './components/order-editing-preview/components/address-validation-preview/address-validation-preview.component';

@NgModule({
  declarations: [
    OrderEditingComponent,
    OrderEditingPreviewComponent,
    OrderEditingFormComponent,
    OrderEditingFormEditsComponent,
    OrderEditingFormRepricingComponent,
    OrderEditingFormRefundHandlingComponent,
    OrderEditingFormShippingComponent,
    OrderEditingFormPeriodComponent,
    OrderEditingHeaderComponent,
    OrderEditingFormAddressValidationComponent,
    AddressValidationConfigurationsComponent,
    AddressValidationFlaggedOrdersComponent,
    AddressValidationPreviewComponent,
  ],
  imports: [CommonModule, StorybookModule, FeaturesModule, SharedModule, SettingsModule],
})
export class OrderEditingModule {}
